import React from 'react';
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const TitleTooltip = ({placement, id, title}) => (
  <OverlayTrigger
    placement={placement}
    overlay={
      <Tooltip id={id}>
        {title}
      </Tooltip>
    }
  >
    <h6>{title}</h6>
  </OverlayTrigger>
)

export default TitleTooltip;
